import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Collapse, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';

import { AppDescriptionList, AppResourceItem, AppTextStyle } from '@shared';

import { statusVariations, ta } from 'utils';
const propTypes = {
  task: PropTypes.object.isRequired,
  extraActions: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.node),]),
}

const defaultProps = {

}

const taskFields = ["addressFullName", "addressLine1", "addressLine3", "telephone"];

// Read-only replacement for the Polaris <OptionList> the order items were shown
// in: the checkboxes were never actionable here, only a record of what shipped.
const OrderItemsList = ({ options, selected }) => (
  <List dense disablePadding>
    { options.map((option) => (
      <ListItem key={option.value} disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <Checkbox edge="start" size="small" disableRipple readOnly checked={selected.includes(option.value)} />
        </ListItemIcon>
        <ListItemText primary={option.label} primaryTypographyProps={{ variant: 'body2' }} />
      </ListItem>
    ))}
  </List>
);

const TaskItem = ({ task, ...props }) => {
  const [open, setOpen] = useState(false);
  const onItemClick = () => setOpen(!open);

  let descriptionItems = [
    { term: "Nombre", description: task.brightpearl_data.name },
    { term: "Dirección", description: task.address },
    { term: "Número de teléfono", description: task.brightpearl_data.phone },
  ];

  if(task.estimated_at){
    descriptionItems = [
      ...descriptionItems,
      { term: ta("task.estimated_at"), description: I18n.l("time.formats.date_only", task.estimated_at) }
    ]
  }

  if(!!task.brightpearl_data?.order_id){
    descriptionItems = [
      ...descriptionItems,
      { term: "Número de Orden", description: task.brightpearl_data.order_reference },
      { term: "ID de Orden", description: task.brightpearl_data.order_id },
      { term: "Productos", description: (
        <OrderItemsList
          options={ task?.brightpearl_data?.order_items || [] }
          selected={ task.item_ids || [] }
        />
      ) },
    ]
  }

  return (
    <AppResourceItem
      id={`${task.typename}-${task.id}`}
      onClick={ onItemClick }
    >
      <div className="flex justifyBetween">
        {/* When compact. Everything gets into two flex columns. All info left and Right only status. Non compact has extra left column only for order number */}
        <div>
          {/* The task name, not a heading — the <h3> was only ever the weight. */}
          <Typography variant="body1" fontWeight="bold">
            { task.name }
          </Typography>
          <p>
            <AppTextStyle variation={ statusVariations[task.status] }>
              {I18n.t(`enum.status.${task.status}`)}
            </AppTextStyle>
          </p>
          <p>
            <AppTextStyle variation={ "subdued" }>
              {I18n.t(`enum.kind.${task.kind}`)}
            </AppTextStyle>
          </p>
        </div>
        <div>
          <p>{ task.team && task.team.name }</p>
          <p>{ task.courier && task.courier.name }</p>
        </div>
      </div>

      {/* Collapsible */}
      <Collapse in={open} id="basic-collapsible" unmountOnExit>
        <div>
          { descriptionItems.length > 0 ?
              <AppDescriptionList
                items={descriptionItems}
              />
            :
            <Typography variant="body2">
              Dirección vacía.
            </Typography>
          }

          { props.extraActions && props.extraActions(task.id, task) }
        </div>
      </Collapse>
    </AppResourceItem>
  )
};

TaskItem.propTypes = propTypes;
TaskItem.defaultProps = defaultProps;

export default TaskItem;
